import { twMerge } from "tailwind-merge"

import { BinocularsIcon } from "@modules/nelo-search/components/search-bar/BinocularsIcon"

type MobileSearchBarProps = {
  onClick: () => void
  className?: string
}

export const MobileSearchBar = ({ onClick, className }: MobileSearchBarProps) => {
  return (
    <button
      onClick={onClick}
      className={twMerge(
        "ml-auto flex h-[39px] w-full max-w-[160px] items-center justify-between rounded-full bg-nelo-light-gray text-xs leading-[16px] tracking-[-2%] lg:hidden",
        className
      )}
    >
      <p className="py-2 pl-4 pr-2 text-[12px] text-nelo-dark-gray">Buscar</p>
      <div className="aspect-square h-full p-[2px]">
        <div className="flex h-full w-full items-center justify-center rounded-full bg-[#077BF2]">
          <BinocularsIcon fontSize="12px" />
        </div>
      </div>
    </button>
  )
}
